import { Children, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  children: ReactNode;
  className?: string;
};

const GraphRow = ({ className = "", children }: Props) => {
  const amountOfChildren = Children.toArray(children).length;
  return (
    <div
      className={twMerge(
        "grid w-full items-stretch gap-2",
        amountOfChildren === 1 &&
          "grid-cols-1 [--aspect:2.248/1] [--headline-font-size:var(--text-6xl)]",
        amountOfChildren === 2 &&
          "grid-cols-2 [--aspect:1.479/1] [--headline-font-size:var(--text-5xl)]",
        amountOfChildren === 3 &&
          "grid-cols-3 [--aspect:1.354/1] [--headline-font-size:var(--text-4xl)]",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default GraphRow;
